/** Klassennamen zusammensetzen; falsy-Werte werden ignoriert */
export const cx = (...classes) => classes.filter(Boolean).join(' ');
